// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15n_m","delete":"styles_delete__3W-Em","update":"styles_update__MhPva","add":"styles_add__PvnGJ"};